import Vue from "vue";

export default function (_store, _router) {
    // Intercept all ajax requests
    Vue.axios.interceptors.request.use(
        function (config) {
            // Do something before request is sent
            // set center id to param
            const currentRoute = _router.currentRoute.name;
            
            const center = _store.getters['navigation/globalCenter']
            if(center && center.id && currentRoute != 'Login'){
                if(config.params){
                    config.params['center-id'] = center.id;
                    config.params['centerId'] = center.id;
                    config.params['center_id'] = center.id;
                }
                else{
                    config.params = {'center-id': center.id, 'centerId': center.id, 'center_id': center.id}
                }

                if( (config.method === 'post' || config.method === 'put') && config.data){
                    config.data['center-id'] = center.id;
                    config.data['center_id'] = center.id;
                    config.data['centerId'] = center.id;
                }
            }
            _store.dispatch('navigation/appLoading');
            // console.log(config)
            return config;
        },
        function (error) {
            // Do something with request error
            return Promise.reject(error).then(error => {
                _store.dispatch('navigation/stopAppLoading');

                _store.commit("ADD_MESSAGE", error);
            });
        }
    );

    // Intercept all ajax responses
    Vue.axios.interceptors.response.use(
        function (response) {
            // Do something with response data
            _store.dispatch('navigation/stopAppLoading');

            return response;
        },
        function (err) {
            _store.dispatch('navigation/stopAppLoading');
            // console.log('Error response')
            // console.log(err.response)
            return new Promise((resolve, reject) => {
                if (!err.response) {
                    // network error
                    const message = 'Network error, please check your internet connection or try again later';
                    _store.dispatch('messages/addErrorMessage', message)
                    reject(err);
                }
                else if (err.response &&
                    err.response.status === 500
                ) {
                    const message = 'Server error, please try again later';
                    _store.dispatch('messages/addMessage', { message, messageClass: 'danger' })
                    reject(err.response);
                }
                else if (err.response &&
                    err.response.status === 401
                ) {
                    _store.dispatch("auth/processLogout");
                    const path = '/login'
                    if (_router.currentRoute.path !== path) _router.push(path)

                    reject(err.response);
                }
                // console.log('Rejecting response')
                reject(err.response);
            });
        }
    );
}
